import React from "react";
import Button from "@shared/v2/Button";
import PopularCard from "./shared/PopularCard";
import { useCurrentUser, useIsPlace } from "../reducers/layoutReducer/selectors";

const BrivityLeadsPopular = () => {
  const currentUser = useCurrentUser();
  const isPlace = useIsPlace();
  return (
    <PopularCard
      title="Brivity Leads"
      description="Whether it’s generating real estate leads or re-engaging your existing database, Brivity’s advertising experts work with you to craft a custom strategy to produce results."
    >
      <Button
        size="medium"
        onClick={() => {
          if (isPlace) {
            window.open(`https://meetings.hubspot.com/amy-gerrish?uuid=${currentUser.uuid}`, "_blank");
          }
        }}
      >
        Get More Leads
      </Button>
      <img src="/images/bg-popular-brivity-leads.png" alt="Brivity Leads" />
    </PopularCard>
  );
};

export default BrivityLeadsPopular;
